<template>
<Box @close="close()">
    <template #top>Generar Reporte</template>
    <template #center>
        <div class="nj-panel">
            <div class="nj-panel-content">
                <div class="nj-gridx">
                    <InputDate label="Fecha inicio" v-model="filtros.fecha_inicio"></InputDate>
                    <InputDate label="Fecha fin" v-model="filtros.fecha_fin"></InputDate>
                </div>
                <br>
                <Button label="Generar reporte" icon="excel" @click="generarReporte()"></Button>
            </div>
        </div>
    </template>
</Box>
</template>
<script>
import { OrdenCompraService, ResponseStatus } from "../../services"
import { ExportarExcel, Toast, Validator } from "../../util"
import { Box, Button, InputDate } from "../components"

export default {
    name: "OrdenCompraReporte1",
    components: {
        Box,
        InputDate,
        Button,
    },
    data() {
        return {
            filtros: {
                fecha_inicio: null,
                fecha_fin: null
            }
        }
    },
    methods: {
        close() {
            this.$emit("close", {
                interfaz: "none",
            })
        },
        generarReporte() {
            if (Validator.start(this.filtros.fecha_inicio, this.filtros.fecha_fin)) {
                OrdenCompraService
                    .generarReporte2({
                        orden_compra: {
                            fecha_inicio: this.filtros.fecha_inicio,
                            fecha_fin: this.filtros.fecha_fin,
                        }
                    })
                    .then(response => {
                        if (ResponseStatus.isSuccess(response)) {
                            ExportarExcel.generar(response.data, "reporte_oc_op")
                            this.close()
                        }
                        else {
                            Toast.error(response.message)
                        }
                    })
                    .catch(error => {
                        Toast.error(error)
                    })
            }
            else {
                Toast.error("Debe ingresar un rango de fechas para generar el reporte")
            }
        },
    },
    mounted() {

    }
}
</script>

<style scoped></style>